<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" icon="md-cloud-upload" style="margin-left: 20px;"
				@click="clickImport">导入Excel</Button>
			<Button type="primary" style="margin-left: 20px;" @click="downTemplate">下载模版</Button>
			<Button type="primary" style="margin-left: 20px;" @click="clickBatchDelete">批量删除</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button type="primary" @click="clickUpdate(row)" style="padding: 5px 5px 6px;">编辑</Button>
					<Button type="primary" @click="clickDelete(row)" style="padding: 5px 5px 6px;">删除</Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
								<span>搜索</span>
			</p>
			<div style="padding-left: 20px;">
				<CheckboxGroup v-model="selectedConditions" class="check_group">
					<div>
						<Checkbox label="name">
							<span>姓名</span>
						</Checkbox>
						<Input v-model="condition.name" placeholder="" />
						</div>
						<div>
							<Checkbox label="mac">
								<span>报警器MAC</span>
							</Checkbox>
							<Input v-model="condition.mac" placeholder="" />
						</div>
						<div>
							<Checkbox label="num">
								<span>设备编号</span>
							</Checkbox>
							<Input v-model="condition.num" placeholder="" />
						</div>
						<div>
							<Checkbox label="type">
								<span>通讯类型</span>
							</Checkbox>
							<Select :readonly="showType=='show'" v-model="condition.type">
								<Option :value="1" :key="1">NB</Option>
								<Option :value="2" :key="2">WIFI</Option>
							</Select>
						</div>
						<div>
							<Checkbox label="gasType">
								<span>用气类型</span>
							</Checkbox>
							<Select :readonly="showType=='show'" v-model="condition.gasType">
								<Option :value="1" :key="1">液化天然气</Option>
								<Option :value="2" :key="2">液化石油气</Option>
							</Select>
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="info" size="large" long @click="searchByCondition">立即搜索</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="showDialog" class="common_update_dialog">
			<div slot="header">
				<span>{{showTitle}}</span>
			</div>
			<div>
				<span>姓名</span>
				<Input :readonly="showType=='show'" v-model="currentRow.name" />
			</div>
			<div>
				<span>电话</span>
				<Input :readonly="showType=='show'" v-model="currentRow.telephone" />
			</div>
			<div>
				<span>地址</span>
				<Input :readonly="showType=='show'" v-model="currentRow.address" />
			</div>
			<div>
				<span>mac地址</span>
				<Input :readonly="showType=='show'" v-model="currentRow.mac" :disabled ="true"/>
			</div>
			<div>
				<span>sim卡号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.iccid" :disabled ="true" />
			</div>
			<div>
				<span>域名</span>
				<Input :readonly="showType=='show'" v-model="currentRow.domain" />
			</div>
			<div>
				<span>基表编号</span>
				<Input :readonly="showType=='show'" v-model="currentRow.baseNum" />
			</div>
			<div>
				<span>端口</span>
				<Input :readonly="showType=='show'" v-model="currentRow.port" type="number" />
			</div>
			<div>
				<span>燃气公司名称</span>
				<Input :readonly="showType=='show'" v-model="currentRow.corporate"/>
			</div>
			<div>
				<span>齿轮系数</span>
				<Input :readonly="showType=='show'" v-model="currentRow.coefficient"/>
			</div>
			<div>
				<span>通讯类型</span>
				<Select :readonly="showType=='show'" v-model="currentRow.type" :disabled ="true">
					<Option :value="1" :key="1">NB</Option>
					<Option :value="2" :key="2">WIFI</Option>
				</Select>
			</div>
			<div>
				<span>用气类型</span>
				<Select :readonly="showType=='show'" v-model="currentRow.gasType" :disabled ="true">
					<Option :value="1" :key="1">液化天然气</Option>
					<Option :value="2" :key="2">液化石油气</Option>
				</Select>
			</div>
			<div slot="footer">
				<Button v-if="showType=='update'" :loading="submitLoading" type="info" size="large" long
					@click="submitUpdate">立即提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "alarm_manage",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "姓名",
						width: 80,
						key: "name",
						align: "center"
					},
					{
						title: "电话",
						width: 140,
						key: "telephone",
						align: "center"
					},
					{
						title: "地址",
						width: 200,
						key: "address",
						align: "center"
					},
					{
						title: "编号",
						width: 180,
						key: "num",
						align: "center"
					},
					{
						title: "MAC地址",
						width: 170,
						key: "mac",
						align: "center"
					},
					{
						title: "公司名称",
						width: 200,
						key: "corporate",
						align: "center"
					},
					{
						title: "域名",
						width: 200,
						key: "domain",
						align: "center"
					},
					{
						title: "端口",
						width: 90,
						key: "port",
						align: "center"
					},
					{
						title: "通讯方式",
						width: 100,
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								params.row.type == 1 ? 'NB' : 'WIFI'
							);
						}
					},
					{
						title: "用气类型",
						width: 120,
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								params.row.gasType == 1 ? "液化天然气" : "液化石油气"
							);
						}
					},
					{
						title: "创建时间",
						width: 200,
						key: "createTime",
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.createTime)
								)
							);
						}
					},
					{
						title: "操作",
						fixed: 'right',
						width: 150,
						slot: "deparams",
						align: "center"
					}
				],
				meterId: '',
				importUrl: '/api/alarm/admin/alarm/imports',
				templateUrl: 'http://www.cnzhuocheng.cn/报警器导入模板.xls',
				selection: [],
				currentRow: {},
				data1: [],
				loading: false,
				condition: {
					id: '',
					mac: '',
					happenTimeRange: [],
				},
				submitLoading: false,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				int:0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindCompany: false,
				bindCompanyNum: '',
				showBindAddress: false,
				bindAddressId: '',
				showType: 'show',
				showTitle: '详情',
				showDialog: false,
			};
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			onUploadSuccess(response, file, fileList,int) {
				this.int++;
				if (!response.success) {
					this.$Notice.error({
						title: "异常",
						desc: response.msg
					});
					this.getDataList();
					return;
				}

				this.$Notice.success({
					title: "提示",
					desc: "导入" + response.data.count + "条，" +
						'成功' + response.data.successCount +
						'条，失败' + response.data.failureCount +
						'条，忽略' + response.data.skipCount + '条'
				});
				this.getDataList();
			},
			downTemplate() {
				window.location.href = this.templateUrl + "?" + new Date();
			},
			clickBatchDelete() {
				let that = this;
				if (that.selection.length == 0) {
					that.$Notice.info({
						title: "提示",
						desc: "请选择数据"
					});
					return;
				}

				let numArray = [];
				for (let i in that.selection) {
					let num = that.selection[i].num;
					numArray.push(num);
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认批量删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/alarm/admin/alarm/batchDelete",
							type: "post",
							data: {
								numJoin: numArray.join(',')
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			clickUpdate(row) {
				this.currentRow = row;
				this.showType = 'update';
				this.showTitle = '编辑';
				this.showDialog = true;
			},
			submitUpdate() {
				let that = this;
				that.submitLoading = true;
				delete that.currentRow.createTime;
				delete that.currentRow.activateTime;
				$.ajax({
					url: "/api/alarm/admin/alarm/update",
					type: "post",
					data: that.currentRow,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "提交成功"
						});
						that.showDialog = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickDelete(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/alarm/admin/alarm/delete",
							type: "post",
							data: {
								num: row.num
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									that.getDataList();
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}
				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (let i in this.selectedConditions) {
					let selectedCondition = this.selectedConditions[i]
					switch (selectedCondition) {
						case 'happenTime':
							let happenTimeBegin = this.condition.happenTimeRange[0];
							if (happenTimeBegin != '') {
								this.requestBody['happenTimeBegin'] = global.dateFtt('yyyy-MM-dd hh:mm:ss',
									happenTimeBegin);
						}
						let happenTimeEnd = this.condition.happenTimeRange[1];
							if (happenTimeEnd != '') {
								this.requestBody['happenTimeEnd'] = global.dateFtt('yyyy-MM-dd hh:mm:ss', happenTimeEnd);
							}
							if (this.id != "") {
								this.requestBody["id"] = this.id;
							}
							if (this.mac != "") {
								this.requestBody["mac"] = this.mac;
							}
							if (this.num != "") {
								this.requestBody["num"] = this.num;
							}
							if (this.type.value != "") {
								this.requestBody["type"] = this.type;
							}
							if (this.gasType.value != "") {
								this.requestBody["gasType"] = this.gasType;
							}
							if (this.subType.value != "") {
								this.requestBody["subType"] = this.subType;
							}
							break;
						default:
							let value = this.condition[selectedCondition];
							if (value == null || value == '') {
								break;
							}

							this.requestBody[selectedCondition] = value;
							break;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				that.loading = true;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
								$.ajax({
					url: "/api/alarm/admin/alarm/getPageList?currentPage=" + that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true&",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
.check_group>div {
		margin-bottom: 10px;
	}

	.check_group>div>label {
		width: 100px;
	}

	.check_group>div>div {
		width: 200px;
	}

	.ivu-date-picker {
		width: 100%;
	}
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
